const runtimeConfig = window.DAVE_APP_CONFIG || {};

// Same-origin production API; local development can still override it.
export const API_BASE = runtimeConfig.apiBase || process.env.REACT_APP_API_BASE || "/api";

let cachedToken = null;
let tokenExpiresAt = 0;

async function getSessionToken(forceRefresh = false) {
  const now = Math.floor(Date.now() / 1000);
  if (!forceRefresh && cachedToken && tokenExpiresAt > now + 30) {
    return cachedToken;
  }

  if (!runtimeConfig.tokenUrl || !runtimeConfig.restNonce) {
    // Development-only compatibility. Never build a production bundle with a shared key.
    const localKey = process.env.NODE_ENV !== "production" && process.env.REACT_APP_DAVE_API_KEY;
    return localKey ? { legacyKey: localKey } : null;
  }

  const response = await fetch(runtimeConfig.tokenUrl, {
    credentials: "same-origin",
    headers: { "X-WP-Nonce": runtimeConfig.restNonce },
  });
  if (!response.ok) {
    throw new Error(response.status === 401 ? "Please sign in to use video evaluation." : "Could not authorize video evaluation.");
  }

  const data = await response.json();
  cachedToken = data.token;
  tokenExpiresAt = Number(data.expiresAt || 0);
  return cachedToken;
}

export async function apiFetch(path, options = {}, retry = true) {
  const token = await getSessionToken();
  const headers = new Headers(options.headers || {});
  if (token?.legacyKey) {
    headers.set("X-DAVE-API-Key", token.legacyKey);
  } else if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    credentials: "same-origin",
    headers,
  });
  if (response.status === 401 && retry && runtimeConfig.tokenUrl) {
    await getSessionToken(true);
    return apiFetch(path, options, false);
  }
  return response;
}
